export const CategorySearchMapping = [
  {
    'maternity dresses': '/category/5366?',
    'maternity wear': '/category/5366?',
    'maternity dress': '/category/5366?',
  },
];

export const trendingSearchDataConstant = [
  { name: 'Baby Diaper pants' },
  {
    name: 'Lactomama',
    url: '/category/Increase-Breast-Milk-Supply-with-LactoMama-Lactation-Granules',
  },
  { name: 'Reusable Cloth Diaper' },
  {
    name: 'Boost Breast Milk Supply',
    url: '/category/Increase-Breast-Milk-Supply-with-LactoMama-Lactation-Granules',
  },
  { name: 'Stretch Marks Cream' },
  { name: 'Wrapper' },
  { name: 'Ovaluna' },
  { name: 'Baby Carrier' },
  { name: 'bath Regime kit' },
  { name: 'Mosquito' },
  { name: 'Baby Wipes' },
];
